const en = {
  // Navbar
  "nav.home": "Home",
  "nav.about": "About Us",
  "nav.presentations": "Sizes",
  "nav.catalog": "Catalog",
  "nav.benefits": "Benefits",
  "nav.locations": "Where to Find Us",
  "nav.contact": "Contact",

  // Hero
  "hero.title": "The authentic Greek yogurt that transforms the natural into an extraordinary moment.",
  "hero.subtitle": "Artisanally crafted in Costa Rica with selected ingredients, high in protein, lactose-free, and designed to savor every spoonful.",
  "hero.cta_catalog": "View Catalog",
  "hero.cta_locations": "Where to Find Us",

  // Benefits
  "benefits.title": "Benefits you can feel",
  "benefits.protein": "High in protein",
  "benefits.protein_desc": "Up to 7g of protein per serving for balanced nutrition.",
  "benefits.lactose_free": "Lactose-free",
  "benefits.lactose_free_desc": "Enjoy worry-free. Perfect for those with lactose intolerance.",
  "benefits.no_sugar": "No added sugar",
  "benefits.no_sugar_desc": "Naturally sweetened. No refined sugars or artificial sweeteners.",
  "benefits.cultures": "Live cultures",
  "benefits.cultures_desc": "Natural probiotics that support digestive health and strengthen the immune system.",
  "benefits.costa_rica": "Made in Costa Rica",
  "benefits.costa_rica_desc": "100% Costa Rican production. We support local talent and ingredients.",
  "benefits.artisanal": "Artisanal production",
  "benefits.artisanal_desc": "Made in small batches with dedication, care, and attention to detail.",

  // About
  "about.title": "Our story",
  "about.subtitle": "From Costa Rica, we craft artisanal Greek yogurt with the highest quality standards.",
  "about.paragraph1": "Kremsi was born from a passion for authentic food. In every batch, we combine traditional techniques with innovation to create an exceptionally creamy and nutritious Greek yogurt.",
  "about.paragraph2": "We carefully select every ingredient. Our artisanal process respects natural fermentation time, achieving an unparalleled texture and a flavor profile that celebrates the purity of nature.",
  "about.paragraph3": "We are a Costa Rican company committed to excellence. Every product that bears our name is the result of dedication, knowledge, and deep respect for Greek tradition.",

  // Presentations
  "presentations.title": "Our sizes",
  "presentations.size_130": "130 g",
  "presentations.size_130_desc": "Perfect for enjoying anytime. Ideal for work, university, or after the gym.",
  "presentations.size_440": "440 g",
  "presentations.size_440_desc": "Perfect for sharing with family. The ideal size to always have at home and enjoy every day.",
  "presentations.size_950": "950 g",
  "presentations.size_950_desc": "Perfect for homes, cafés, and restaurants. The most generous option for true Greek yogurt lovers.",

  // Catalog
  "catalog.title": "Our catalog",
  "catalog.tab_130": "130 g",
  "catalog.tab_440": "440 g",
  "catalog.tab_950": "950 g",
  "catalog.modal_close": "Close",
  "catalog.ingredients": "Key ingredients",
  "catalog.benefits": "Benefits",
  "catalog.storage": "Storage",
  "catalog.consumption": "How to enjoy",
  "catalog.presentation": "Size",

  // Products 130g
  "product.berries.name": "Berries",
  "product.berries.desc": "Lactose-free Greek yogurt with a blend of selected red berries.",
  "product.chocolate.name": "Chocolate",
  "product.chocolate.desc": "Lactose-free Greek yogurt with authentic Costa Rican chocolate.",
  "product.cas.name": "Cas",
  "product.cas.desc": "Lactose-free Greek yogurt with the tropical flavor of Costa Rican cas fruit.",
  "product.strawberry.name": "Strawberry",
  "product.strawberry.desc": "Lactose-free Greek yogurt with carefully selected fresh strawberries.",
  "product.mango_maracuya.name": "Mango Passion Fruit",
  "product.mango_maracuya.desc": "Lactose-free Greek yogurt with the perfect tropical combination of mango and passion fruit.",
  "product.pina_colada.name": "Piña Coco",
  "product.pina_colada.desc": "Lactose-free Greek yogurt with the refreshing flavor of pineapple and coconut.",
  "product.sandia.name": "Watermelon",
  "product.sandia.desc": "Lactose-free Greek yogurt with the refreshing, sweet flavor of watermelon.",
  "product.taro.name": "Taro",
  "product.taro.desc": "Lactose-free Greek yogurt with the delicate and exquisite flavor of taro.",
  "product.vainilla.name": "Vanilla",
  "product.vainilla.desc": "Lactose-free Greek yogurt with natural vanilla. An irresistible classic.",
  "product.coco.name": "Coconut Base",
  "product.coco.desc": "Vegan Greek-style yogurt made with coconut base. Creamy and completely plant-based.",

  // Products 440g
  "product.natural.name": "Natural",
  "product.natural.desc": "Natural lactose-free Greek yogurt. The purest expression of our artisanal tradition.",

  // Why Choose
  "why.title": "Why choose Kremsi?",
  "why.ingredients": "Natural ingredients",
  "why.ingredients_desc": "Only real ingredients, nothing artificial. Nature in its purest form.",
  "why.no_preservatives": "No preservatives",
  "why.no_preservatives_desc": "Authentic freshness without additives. The way real yogurt should be.",
  "why.lactose_free": "Lactose-free",
  "why.lactose_free_desc": "All the creaminess of Greek yogurt without lactose. So everyone can enjoy.",
  "why.protein": "High in protein",
  "why.protein_desc": "Real nutrition in every spoonful. Perfect for an active and healthy lifestyle.",
  "why.artisanal": "Artisanal production",
  "why.artisanal_desc": "Small batches, great dedication. Every yogurt is crafted with artisanal care.",
  "why.local": "Made in Costa Rica",
  "why.local_desc": "Proudly Costa Rican. We support local producers and our country's economy.",

  // Locations
  "locations.title": "Where to find us",
  "locations.subtitle": "Our products are available at selected supermarkets across Costa Rica.",
  "locations.whatsapp": "Check availability via WhatsApp",

  // Instagram
  "instagram.title": "Follow us on Instagram",
  "instagram.subtitle": "Discover recipes, news, and the day-to-day of Kremsi.",
  "instagram.follow": "Follow on Instagram",

  // Contact
  "contact.title": "Contact",
  "contact.subtitle": "We are here for you. Write to us and we will respond as soon as possible.",
  "contact.whatsapp": "WhatsApp",
  "contact.email": "Email",
  "contact.hours": "Hours",
  "contact.hours_value": "Monday to Friday: 8:00 AM - 5:00 PM",
  "contact.location": "Location",
  "contact.location_value": "Guadalupe, San José",
  "contact.form_name": "Name",
  "contact.form_email": "Email",
  "contact.form_message": "Message",
  "contact.form_send": "Send inquiry",
  "contact.form_success": "Thank you for your message! We'll get back to you soon.",
  "contact.form_error": "There was an error sending. Please try again.",

  // Footer
  "footer.description": "Costa Rican artisanal Greek yogurt. Made with selected ingredients, no preservatives, and the authentic taste of nature.",
  "footer.quick_links": "Quick links",
  "footer.rights": "All rights reserved.",

  // Shared
  "language.es": "ES",
  "language.en": "EN",
  "site.name": "Kremsi",
};

export default en;